import { superAdminApi } from "../authService";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../../types/api";
import { AppNotification } from "../notificationService";

const RESOURCE = "/super-admin/notifications";

export const listAdminNotifications = async (
  params?: PaginationParams
): Promise<PaginatedApiResponse<AppNotification>> => {
  const response = await superAdminApi.get<PaginatedApiResponse<AppNotification>>(
    RESOURCE,
    { params }
  );

  return response.data;
};

export const markAdminNotificationAsRead = async (
  id: string
): Promise<ApiResponse<AppNotification>> => {
  const response = await superAdminApi.patch<ApiResponse<AppNotification>>(
    `${RESOURCE}/${id}/read`
  );

  return response.data;
};

export const markAllAdminNotificationsAsRead = async (): Promise<
  ApiResponse<{ updated_count: number }>
> => {
  const response = await superAdminApi.patch<
    ApiResponse<{ updated_count: number }>
  >(`${RESOURCE}/read-all`);

  return response.data;
};
